<template>
  <svg
    :width="chartWidth"
    :height="chartHeight"
    :viewBox.camel="viewBox"
    v-bind="chartBind"
    @mousedown="handleMousedown"
    @mousemove="handleMousemove"
    @touchstart="handleMousedown"
    @touchmove="handleMousemove"
  >
    <g
      class="Chart-grid"
      :key="`${keyPrefix}:${display.id}`"
      style="user-select: none"
    >
      <g :id="gridKey"></g>
    </g>
    <g class="Chart-content" v-if="layers.length">
      <g
        v-for="layer in layers"
        :key="`${keyPrefix}:${layer.id}`"
        class="Chart-layer"
        :zIndex="layer.zIndex"
      >
        <component
          :is="`datalas-${layer.type}`"
          v-bind="layer"
          :fields="fields"
          :chart-data="data"
          :chart-width="chartWidth"
          :chart-height="chartHeight"
          :is-mobile-width="isMobileWidth"
          :transforms="processedTranformers"
          :context="display"
          :grid-key="gridKey"
          :grid-mounted="gridMounted"
          :viewboxPosition="viewboxPosition"
          :widgetContentWrapperRect="widgetContentWrapperRect"
          :marginLeft="marginLeft"
          @datum:mouseover="$emit('datum:mouseover', $event)"
          @datum:mouseout="$emit('datum:mouseout', $event)"
          @datum:click="$emit('datum:click', $event)"
          @update:layoutPaddings="$emit('update:layoutPaddings', $event)"
          @update:axisTickSize="$emit('update:axisTickSize', $event)"
          @update:axisSize="$emit('update:axisSize', $event)"
          @update:layoutTotalBandwidth="
            $emit('update:layoutTotalBandwidth', $event)
          "
        />
      </g>
    </g>
    <g class="Chart-grid" style="user-select: none">
      <g :id="`${gridKey}-overlay`"></g>
    </g>
  </svg>
</template>

<script>
import Chart from './chart.vue';

export default {
  name: 'DatalasFlexibleChart',

  extends: Chart,

  emits: [
    'update:axisTickSize',
    'update:axisSize',
    'update:layoutPaddings',
    'update:layoutTotalBandwidth',
  ],
  data: () => ({
    mousedown: false,
    mouseStartPosition: { x: 0, y: 0 },
    viewboxStartPosition: { x: 0, y: 0 },
    viewboxPosition: { x: 0, y: 0 },

    // to track gragging speed
    momentumID: undefined,
    velX: undefined,
  }),
  props: {
    config: {
      type: Object,
      default: () => ({}),
    },

    height: {
      type: Number,
    },
    width: {
      type: Number,
    },
    isMobileWidth: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    transforms: {
      type: Array,
      default: () => [],
    },
    display: {
      type: Object,
      default: () => ({}),
    },
    children: {
      type: Array,
      default: null,
    },
    keyPrefix: {
      type: String,
      default: '',
    },

    widgetContentWrapperRect: {
      type: Object,
      default: () => ({ width: 0, height: 0 }),
    },
    marginLeft: Number,
  },

  computed: {
    viewBox() {
      const viewBox = `0 0 ${this.chartWidth} ${this.chartHeight}`;

      return this.config.scale === 'relative' && viewBox;
    },
    chartSize() {
      return this.width - this.widgetContentWrapperRect.width;
    },
  },
  methods: {
    beginMomentumTracking() {
      this.cancelMomentumTracking();

      this.momentumID = requestAnimationFrame(this.momentumLoop);
    },
    cancelMomentumTracking() {
      cancelAnimationFrame(this.momentumID);
    },
    momentumLoop() {
      if (
        Math.abs(this.viewboxPosition.x + this.velX) <= this.chartSize &&
        this.viewboxPosition.x + this.velX <= 0
      ) {
        this.viewboxPosition.x += this.velX;
      }

      this.velX *= 0.95;
      if (Math.abs(this.velX) > 0.25) {
        this.momentumID = requestAnimationFrame(this.momentumLoop);
      }
    },

    handleMousedown(e) {
      this.mouseDown = true;

      const userEvent = e.touches ? e.touches[0] : e;

      this.mouseStartPosition.x = userEvent.pageX;

      this.viewboxStartPosition.x = this.viewboxPosition.x;

      window.addEventListener('touchend', this.handleMouseup);
      window.addEventListener('mouseup', this.handleMouseup);

      this.cancelMomentumTracking(); // Stop the drag momentum loop
    },
    handleMousemove(e) {
      if (!this.mouseDown) return;

      e.preventDefault();

      const userEvent = e.touches ? e.touches[0] : e;

      const walk = this.mouseStartPosition.x - userEvent.pageX;

      // Store the previous scroll position
      const prevViewboxPositionX = this.viewboxPosition.x;

      const vieboxMathedValue = Math.abs(this.viewboxPosition.x);

      // In this place, the dragging is limited so that it always remains in the field of view
      if (
        (!(vieboxMathedValue >= this.chartSize) || walk < 0) &&
        (this.viewboxPosition.x < 0 || walk > 0)
      ) {
        if (walk < 0) {
          const calculatedValue =
            this.viewboxStartPosition.x - walk > 0
              ? 0
              : this.viewboxStartPosition.x - walk;
          this.viewboxPosition.x = calculatedValue;
        } else {
          const calculatedValue =
            vieboxMathedValue - walk > this.chartSize
              ? -this.chartSize
              : this.viewboxStartPosition.x - walk;
          this.viewboxPosition.x = calculatedValue;
        }
      }

      this.velX = this.viewboxPosition.x - prevViewboxPositionX;
    },
    handleMouseup() {
      window.removeEventListener('mouseup', this.handleMouseup);

      this.mouseDown = false;

      // Start a frame loop to continue drag momentum
      this.beginMomentumTracking();
    },
  },
};
</script>
